/**
 * The `home` namespace, split by area so each part of the feature owns its own
 * strings: `page` (HomePage, banner, empty state, grid, create menu, toasts and
 * dialogs), `cards` (object cards, move and share modals) and `testAgent`
 * (the Test Agent panel). The parts' top-level keys never overlap.
 */
import pageEn from './page.en.json';
import pageEs from './page.es.json';
import pagePt from './page.pt.json';
import cardsEn from './cards.en.json';
import cardsEs from './cards.es.json';
import cardsPt from './cards.pt.json';
import testAgentEn from './testAgent.en.json';
import testAgentEs from './testAgent.es.json';
import testAgentPt from './testAgent.pt.json';

export const en = { ...pageEn, ...cardsEn, ...testAgentEn };
export const es = { ...pageEs, ...cardsEs, ...testAgentEs };
export const pt = { ...pagePt, ...cardsPt, ...testAgentPt };

export const NS = 'home' as const;
